import { Component, OnInit, OnDestroy } from "@angular/core";
import { ContextMenuHelperService } from "./context-menu-helper.service";
import { CONTEXT_MENU_CONFIG } from "./menu_config";
import { FaceSDK } from "@identy/identy-face";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { EnumUiOption, LocalizationItem} from "src/app/modules/models/types";
import { MenuConfigService } from "../../../services/menu-config.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-title-context-menu",
  templateUrl: "./title-context-menu.component.html",
  styleUrls: ["./title-context-menu.component.css"]
})
export class TitleContextMenuComponent implements OnInit {
  menu_options = CONTEXT_MENU_CONFIG;
  client_version: string;
  server_version: string;
  localizations: Array<EnumUiOption<LocalizationItem<any>>> = [];
  private menuConfigSubscription: Subscription;

  constructor(
    public context_menu_service: ContextMenuHelperService,
    private http: HttpClient,
    private menuConfigService: MenuConfigService
  ) {}



  ngOnInit() {
    // Subscribe to menu configuration changes
    this.menuConfigSubscription = this.menuConfigService.menuConfig$.subscribe(config => {
      this.menu_options = config;
      // Re-apply localization values after config update
      this.updateLocalizationValues();
    });

    this.client_version = FaceSDK.version();
    this.get_server_version().subscribe((resp) => {
      this.server_version = resp;
    });

    this.localizations = [
      {
        name: "English",
        selected: true,
        option: {
          en: {
            FEEDBACK_CAPTURED: "Captured Successfully",
            FEEDBACK_SEARCHING: "Searching",
            FEEDBACK_INSIDE_GUIDE: "Please be inside the guide",
            FEEDBACK_PLEASE_HOLD: "Please hold",
            FEEDBACK_EYE_LEVEL: "Look Straight",
            FEEDBACK_UP_FACING: "Look Down to be parallel to camera",
            FEEDBACK_DOWN_FACING: "Look up to be parallel to camera",
            FEEDBACK_FACE_OUTSIDE: "Please be inside guide",
            FEEDBACK_CLOSE: "Move Away",
            FEEDBACK_FAR: "Move Close",
            FEEDBACK_LEFT_FACING: "Looking Left, Please Look straight",
            FEEDBACK_RIGHT_FACING: "Looking Right, Please Look straight",
            FEEDBACK_ROTATED: "Look Straight",
            FEEDBACK_NOT_STABLE: "Please be stable",
            FEEDBACK_OK: "Please Hold",
            FEEDBACK_NOT_CENTERED: "Center Face in oval",
            FEEDBACK_PROCESSING: "Processing...",
            FEEDBACK_INITIALIZATION: "Initializing...",
            FEEDBACK_CHANGE_LIGHT: "Avoid shadows",
            FEEDBACK_CHANGE_LIGHT_TOO_BRIGHT: "Too Bright, Move to better lighting.",
            FEEDBACK_CHANGE_LIGHT_TOO_DARK: "Too Dark, Move to better lighting.",
            FEEDBACK_TRAINING_BUTTON_NEXT: "Next",
            FEEDBACK_TRAINING_LABEL: "Dont Show again",
            FEEDBACK_ONLY_PORTRAIT: "Capture Works only in <strong>portrait</strong> mode",
            FEEDBACK_RETAKE_HEADER: "We need to capture again.",
            FEEDBACK_RETAKE_CONTENT: "Please look for better lighting",
            FEEDBACK_RETAKE_YOUR_IMAGE: "Your Image",
            FEEDBACK_RETAKE_OPTIMAL_IMAGE: "Optimal Image",
            FEEDBACK_RETAKE_BUTTON: "Capture again",
            FEEDBACK_RETAKE_BUTTON_CLOSE: "Close",
            FEEDBACK_OPEN_EYES : "Open your eyes",
            FEEDBACK_CLOSE_MOUTH : "Close your mouth",
            FEEDBACK_REMOVE_ARM : "Remove arm from face",
            FEEDBACK_REMOVE_GLASSES : "Remove your glasses",
            FEEDBACK_REMOVE_HAND : "Remove your hand over face",
            FEEDBACK_REMOVE_HAT : "Remove your hat",
            FEEDBACK_REMOVE_HEADSCARF : "Remove headscarf",
            FEEDBACK_REMOVE_HELMET : "Remove helmet",
            FEEDBACK_REMOVE_MASK : "Remove mask",
            FEEDBACK_REMOVE_SUNGLASSES : "Remove sunglasses",
            FEEDBACK_POWERED_BY: "powered by Identy.io",
            FEEDBACK_VIDEO_CHALLENGE_STOP: "Stop",
            FEEDBACK_VIDEO_CHALLENGE: "Please read the following text aloud",
            FEEDBACK_VIDEO_HOLD_ID_CARD: "Hold your ID card, inside the card region",
            FEEDBACK_VIDEO_SHOW_PHOTO: "Make sure your card shows your photo",
            FEEDBACK_VIDEO_HOLD_STEADY: "Hold steady..."
          }
        }
      },
      {
        name: "Spanish",
        selected: false,
        option: {
          en: {
            FEEDBACK_CAPTURED: "Captura exitosa",
            FEEDBACK_SEARCHING: "Buscando",
            FEEDBACK_INSIDE_GUIDE: "Coloque su cara dentro del óvalo",
            FEEDBACK_PLEASE_HOLD: "No se mueva",
            FEEDBACK_EYE_LEVEL: "Mire de frente",
            FEEDBACK_UP_FACING: "Inclina la cabeza hacia abajo, barbilla perpendicular al dispositivo",
            FEEDBACK_DOWN_FACING: "Inclina la cabeza hacia arriba, barbilla perpendicular al dispositivo",
            FEEDBACK_FACE_OUTSIDE: "Coloque su cara dentro del óvalo",
            FEEDBACK_CLOSE: "Aléjese del dispositivo",
            FEEDBACK_FAR: "Acérquese al dispositivo",
            FEEDBACK_LEFT_FACING: "Cabeza inclinada hacia la izquierda, mire de frente",
            FEEDBACK_RIGHT_FACING: "Cabeza inclinada hacia la derecha, mire de frente",
            FEEDBACK_ROTATED: "Mire de frente",
            FEEDBACK_NOT_STABLE: "No se mueva",
            FEEDBACK_OK: "No se mueva",
            FEEDBACK_NOT_CENTERED: "Coloque su cara dentro del óvalo",
            FEEDBACK_PROCESSING: "Procesando...",
            FEEDBACK_INITIALIZATION: "Inicializando...",
            FEEDBACK_CHANGE_LIGHT: "Evite reflejos y sombras",
            FEEDBACK_CHANGE_LIGHT_TOO_BRIGHT: "Entorno muy iluminado, muévase a un entorno con mejor iluminación",
            FEEDBACK_CHANGE_LIGHT_TOO_DARK: "Entorno muy oscuro, muévase a un entorno con mejor iluminación",
            FEEDBACK_TRAINING_BUTTON_NEXT: "Siguiente",
            FEEDBACK_TRAINING_LABEL: "No mostrar de nuevo",
            FEEDBACK_ONLY_PORTRAIT: "Posición <strong>vertical</strong> requerida",
            FEEDBACK_RETAKE_HEADER: "Necesitamos recapturar",
            FEEDBACK_RETAKE_CONTENT: "Muévase a un entorno con mejor iluminación",
            FEEDBACK_RETAKE_YOUR_IMAGE: "Su captura",
            FEEDBACK_RETAKE_OPTIMAL_IMAGE: "Captura óptima",
            FEEDBACK_RETAKE_BUTTON: "Recaptura",
            FEEDBACK_RETAKE_BUTTON_CLOSE: "Cerrar",
            FEEDBACK_OPEN_EYES : "Abre los ojos",
            FEEDBACK_CLOSE_MOUTH : "Cierra la boca",
            FEEDBACK_REMOVE_ARM : "Retira el brazo de tu cara",
            FEEDBACK_REMOVE_GLASSES : "Quítate las gafas",
            FEEDBACK_REMOVE_HAND : "Retira la mano de tu cara",
            FEEDBACK_REMOVE_HAT : "Quítate el sombrero",
            FEEDBACK_REMOVE_HEADSCARF : "Quítate el pañuelo",
            FEEDBACK_REMOVE_HELMET : "Quítate el casco",
            FEEDBACK_REMOVE_MASK : "Quítate la mascarilla",
            FEEDBACK_REMOVE_SUNGLASSES : "Quítate las gafas de sol",
            FEEDBACK_POWERED_BY: "powered by Identy.io",
            FEEDBACK_VIDEO_CHALLENGE_STOP: "Detener",
            FEEDBACK_VIDEO_CHALLENGE: "Por favor, lea el siguiente texto en voz alta",
            FEEDBACK_VIDEO_HOLD_ID_CARD: "Sostén tu tarjeta de identificación dentro del área de la tarjeta",
            FEEDBACK_VIDEO_SHOW_PHOTO: "Asegúrate de que tu tarjeta muestre tu foto",
            FEEDBACK_VIDEO_HOLD_STEADY: "Mantente quieto...",
          }
        }
      }
    ];

    this.updateLocalizationValues();
    this.context_menu_service.allLocalizations = this.localizations;

  const defaultLoc = this.localizations.find(l => l.selected) || this.localizations[0];
  if (defaultLoc) {
    this.context_menu_service.localization = defaultLoc;
    this.context_menu_service.value_change('localization', {
      localization: defaultLoc.name
    });
  }
  }
  get_server_version() {
    const headers = new HttpHeaders().set("Content-Type", "text/plain; charset=utf-8");
    return this.http.get<any>(`${environment.url_processing}/api/v1/version`, {
      headers,
      responseType: "text" as "json"
    });
  }

onValueChange(value: any) {

  if (value.localization) {
    this.localizations.forEach(loc => loc.selected = (loc.name === value.localization));
    const selected = this.localizations.find(loc => loc.selected);
    if (selected) {
      this.context_menu_service.localization = selected;
    }
  }
}

  /**
   * Update localization values in menu configuration
   * Called after menu_options is updated
   */
  private updateLocalizationValues() {
    if (!this.menu_options || !this.localizations.length) {
      return;
    }

    const locGroup = this.menu_options.find(group => group.label === 'Localization');
    if (locGroup && locGroup.type === 'group' && locGroup.options) {
      const locField = locGroup.options.find(opt =>
        (opt as any).field === 'localization'
      ) as any;

      if (locField) {
        locField.values = this.localizations.map(loc => loc.name);
      }
    }
  }

  ngOnDestroy() {
    if (this.menuConfigSubscription) {
      this.menuConfigSubscription.unsubscribe();
    }
  }
}
